import { values } from '@fortem-monorepo/js-utilities';
export const CONTRACT_SIDE = {
    LongLowerShortUpper: 'longLowerShortUpper',
    ShortLowerLongUpper: 'shortLowerLongUpper',
};
export const CONTRACT_SIDES = values(CONTRACT_SIDE);
